






import { GPSLocation } from '@/types/entity';
import { Component, Vue } from 'vue-property-decorator';
// tslint:disable-next-line: no-var-requires
const googleMapStyle = require('../config/googleMapStyle.json');
declare var google: any;
@Component({
    props: {
        route: Object,
        liveTracking: {
            type: Boolean,
            default: false,
        },
        location: Object,
    },
})
export default class GoogleMap extends Vue {

    private marker = {} as any;
    private map = {} as any;
    private positionX: GPSLocation | undefined = undefined;
    private positionY: GPSLocation | undefined = undefined;
    private deltaLat = 0;
    private deltaLng = 0;
    private numDeltas = 500;
    private i = 0;
    public mounted() {
        this.initMap();
    }

    public updateLocation(location: GPSLocation) {
        if (!this.positionX) {
            this.positionX = this.$props.location;
            this.positionY = location;
        } else {
            this.positionX = this.positionY;
            this.positionY = location;
        }
        if (this.positionX && this.positionY) {
            const latLng = new google.maps.LatLng(this.positionX.latitude, this.positionX.longitude);
            this.marker.setPosition(latLng);
            this.map.setCenter(latLng);
            this.i = 0;
            this.deltaLat = (this.positionY.latitude - this.positionX.latitude) / this.numDeltas;
            this.deltaLng = (this.positionY.longitude - this.positionX.longitude) / this.numDeltas;
            this.moveMarker();
        }
    }

    private moveMarker() {
        if (this.positionX && this.positionX.latitude && this.positionX && this.positionX.longitude) {
            this.positionX.latitude += this.deltaLat;
            this.positionX.longitude += this.deltaLng;
            const latlng = new google.maps.LatLng(this.positionX.latitude, this.positionX.longitude);
            this.marker.setPosition(latlng);
            this.map.setCenter(latlng);
            if (this.i !== this.numDeltas) {
                this.i++;
                setTimeout(this.moveMarker, 10);
            }
        }
    }

    private initMap() {
        if (this.$props.liveTracking) {
            this.map = new google.maps.Map(this.$refs.map, {
                center: new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude),
                styles: googleMapStyle,
                zoom: 18,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            // const bounds = new google.maps.LatLngBounds();
            // bounds.extend(new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude));
            // this.map.fitBounds(bounds);
            this.marker = new google.maps.Marker({
                position: new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude),
                map: this.map,
                title: 'Driver Location',
            });
        } else {
            const directionsRenderer = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                polylineOptions: {
                    strokeColor: '#11439c',
                },
            });
            const directionsService = new google.maps.DirectionsService();
            const map = new google.maps.Map(this.$refs.map, {
                styles: googleMapStyle,
                zoom: 24,
            });
            directionsRenderer.setMap(map);
            const bounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(this.$props.route.origin.lat, this.$props.route.origin.lng));
            bounds.extend(new google.maps.LatLng(this.$props.route.destination.lat, this.$props.route.destination.lng));
            map.fitBounds(bounds);
            const selectedMode = 'DRIVING';
            const icons = {
                start: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.origin.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(10, 10),
                ),
                end: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.destination.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(22, 32),
                ),
                stop: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.stops.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(22, 32),
                ),
            };
            const waypoints: any = [];
            if (this.$props.route.additionalStops && this.$props.route.additionalStops.length > 0) {
                this.$props.route.additionalStops.forEach((stop: any) => {
                    waypoints.push({
                        location: new google.maps.LatLng(stop.address.latitude, stop.address.longitude),
                        stopover: true,
                    });
                });
            }
            directionsService.route(
                {
                    destination: this.$props.route.destination,
                    origin: this.$props.route.origin,
                    travelMode: google.maps.TravelMode[selectedMode],
                    waypoints,
                },
                (response: any, status: any) => {
                    if (status === 'OK') {
                        directionsRenderer.setDirections(response);
                        if (response.routes[0].legs.length > 1) {
                            const legA = response.routes[0].legs[0];
                            const legB = response.routes[0].legs[1];
                            const marker1 = new google.maps.Marker({
                                position: legA.start_location,
                                map,
                                icon: icons.start,
                                title: legA.start_address,
                            });
                            const marker2 = new google.maps.Marker({
                                position: legA.end_location,
                                map,
                                icon: icons.stop,
                                title: legA.end_address,
                            });
                            const marker3 = new google.maps.Marker({
                                position: legB.end_location,
                                map,
                                icon: icons.end,
                                title: legB.end_address,
                            });
                        } else {
                            const leg = response.routes[0].legs[0];
                            const marker1 = new google.maps.Marker({
                                position: leg.start_location,
                                map,
                                icon: icons.start,
                                title: leg.start_address,
                            });
                            const marker2 = new google.maps.Marker({
                                position: leg.end_location,
                                map,
                                icon: icons.end,
                                title: leg.end_address,
                            });
                        }
                    } else {
                        window.alert('Directions request failed due to ' + status);
                    }
                },
            );
        }
    }
}

